'use strict';

angular.module('AcaApp').factory('CommonTransmittalService', [
  'SendService',
  'ManagedUserInformationService',
  'UtilsService',
  'ERROR',
  'SETTINGS',
  '$window',
  '$mdDialog',
  'CORRECTIONS_PAGE',
  '$route',
  function (SendService, ManagedUserInformationService, UtilsService, ERROR, SETTINGS, window, mdDialog, CORRECTIONS_PAGE, route) {

    function cancelTransmittal(xmitRun, scope) {
      var cancelRequestXmit = {
        Fchar: scope.form.selected,
        XmitRun: xmitRun.toString(),
        JobId: scope.jobId || 0,
        Hash: scope.hash || window.sessionStorage.hash,
        IsManagedServices: ManagedUserInformationService.isManagedServices(),
        Customer: ManagedUserInformationService.getCustomerName(),
        Cid: ManagedUserInformationService.getCID(),
        TypeTitle: UtilsService.firstLetterUppercase(SETTINGS.TRANSMITTAL)
      };
      SendService.CancelXmit(cancelRequestXmit).then(function (data) {
        if (data.result.Success) {
          if (ManagedUserInformationService.isManagedServicesAndNotSovosProfile()) {
            scope.GoToSendTransmittalPage();
          }
          else {
            mdDialog.hide();
            route.reload();
          };
        }
        else {
          mdDialog.hide();
          var configuration = {
            titleMessage: ERROR.TRANSMITTAL.ERRORTITLE,
            actionMessage: ERROR.TRANSMITTAL.ERRORCANCELTRANSMITTAL,
            supportAssistance: ERROR.TRANSMITTAL.SUPPORTASSIST,
            button: CORRECTIONS_PAGE.BACK_OPTIONS_BUTTON
          };
          if (data.result.Error !== undefined && data.result.Error !== '') {
            scope.errorMessage = data.result.Error;
          }
          else {
            scope.errorMessage = CORRECTIONS_PAGE.SYSTEM_ERROR;
          }
          configuration.errorMessage = scope.errorMessage;
          scope.configuration = configuration;
          scope.options = {
            sendPage: ERROR.ERRORAPAGE
          };
          scope.retransmit = {
            step: ERROR.ERRORAPAGE
          };
          scope.correctionsPage = ERROR.ERRORAPAGE;
        };
      });
    };
   
    return {
      cancelTransmittal: cancelTransmittal
    };
  }
]);